<template>
  <div>
    <div class="left">
      <div v-if="!editPlayDayState">
        <b class="hiddenText" style="width: 1.2rem;" v-if="chenckBudget.departureDate">
          {{dateFormatYMD(chenckBudget.departureDate,'-')}}&nbsp;出发
        </b>
        <b v-else class="hiddenText" style="width: 1.2rem;">暂无出发日期</b>
        <span class="daybox">{{chenckBudget.planDay}}天</span>
        <a @click="changePlanDayAndStartDate" v-show="showShaft==1">更改天数</a>
      </div>
      <div v-else >
        <span class="dateBox">
          <el-date-picker v-model="departureDate" size="mini" style="    width: 1.1rem;" type="date" :clearable="false" 
            placeholder="选择日期" value-format="yyyy-MM-dd"></el-date-picker>
        </span>
        <el-select v-model="playDayNumber" size="mini" placeholder="" style="width:0.6rem;">
          <el-option v-for="i in 60" :key="i" :label="i" :value="i"> </el-option>
        </el-select>
        <a @click="editPlayDayState=false">取消</a>
        <a @click="saveChangePlanDays">保存</a>
      </div>
      <div class="leftChild">
        <div v-for="(item,index) in chenckBudget.planDayList" :key="index" @click.stop="changePlanDay(item)"
          :style="item.planDay==checkPlanDay?'background: rgb(220, 220, 220);':''" :id="'planDay'+item.planDay">
          <div class="planDay">D{{item.planDay}}</div>
          <div class="citycenter">
            <p>
              {{item.planDate?dateFormatYMD(new Date(item.planDate).getTime(),"-"):'暂无出发日期'}} 
              {{getWeekDate(item.planDate)}}
            </p>
            <div v-if="item.cityList.length>0" style="margin:0.13rem 0.15rem 0px 0px">
              <template v-for="(i,ind) in item.cityList">
                <span :key="ind" @click.stop="changePlanDay(item,i)">
                  <el-popover placement="top" trigger="hover" :close-delay="0" v-model="i.openKuang" v-show="showShaft==1">
                    <div style="text-align: right; margin: 0;">
                      <el-button type="success" icon="el-icon-back" circle size="mini" v-if="ind!=0"
                        @click="changeCitySort(i,item.cityList[ind-1],item)"></el-button>
                      <el-button type="warning" icon="el-icon-right" circle size="mini" 
                        @click="changeCitySort(item.cityList[ind+1],i,item)" v-if="ind!=(item.cityList.length-1)"></el-button>
                      <el-button type="warning" icon="el-icon-delete" circle size="mini"
                        @click="delPlanCity(i,ind,item.cityList,item)"></el-button>
                      <el-button type="warning" icon="el-icon-edit" @click="updateCityName(i,item)" circle size="mini"></el-button>
                    </div>
                    <span slot="reference" style="cursor: pointer;font-size: 0.16rem;font-weight: bold;">{{i.cityName}}</span>
                  </el-popover>
                  <div v-show="showShaft==2" style="font-size: 0.16rem;font-weight: bold;margin-bottom: 0.1rem;">{{i.cityName}}</div>
                  <el-popover placement="top" trigger="hover" :close-delay="0" v-show="showShaft==1">
                    <div style="text-align: center; margin: 0;">
                      <img src="@/assets/svg/car.svg" style="width:26px;height:20px;" @click="changeTrafficType(i,1)"/>
                      <img src="@/assets/svg/ship.svg" style="width:26px;height:20px;" @click="changeTrafficType(i,4)"/>
                      <img src="@/assets/svg/train.svg" style="width:26px;height:20px;" @click="changeTrafficType(i,3)"/>
                      <img src="@/assets/svg/air.svg" style="width:26px;height:20px;" @click="changeTrafficType(i,2)"/>
                    </div>
                    <span slot="reference" style="cursor: pointer;" >
                      <img v-if="ind!=(item.cityList.length-1)" :src="require('@/assets/svg/'+(i.trafficType==2?'air.svg':i.trafficType==3?
                        'train.svg':i.trafficType==4?'ship.svg':'car.svg'))" style="width:0.1rem;height:0.1rem;margin: 0.05rem 0.05rem 0 0.05rem;" alt /></span>
                  </el-popover>
                </span>
              </template>
            </div>
            <b @click.stop="addCity(item,index)" v-show="showShaft==1&&!item.inputShowState">
              <i class="el-icon-plus"></i>增加城市
            </b>
            <div v-show="item.inputShowState" @click.stop="" style="margin-bottom: 0.1rem;" :style="item.inputShowState?'margin-top:0.1rem':''">
              <city-autocomplete :obj="city" :ref="'cityAutocomplete'+index" :action="false" @handleSelect="handleSelect($event,item)"></city-autocomplete>
            </div>
            <p>城市间驾车距离：无</p>
          </div>
          <div class="oprateCityDiv">     
            <el-tooltip class="item" effect="dark" content="插入前一天" placement="right" v-show="showShaft==1">
              <p :style="item.planDay==checkPlanDay?'background:#fff':''" @click.stop="updatePlanDay(1,item)">
                <img src="../../../assets/svg/moveup.svg" alt />
              </p>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="插入后一天" placement="right" v-show="showShaft==1">
              <p :style="item.planDay==checkPlanDay?'background:#fff':''" @click.stop="updatePlanDay(2,item)">
                <img src="../../../assets/svg/movedown.svg" alt/>
              </p>
            </el-tooltip>
            <el-tooltip class="item" effect="dark" content="删除当天行程" placement="right" v-show="showShaft==1" >
              <p :style="item.planDay==checkPlanDay?'background:#fff':''" @click.stop="deletePlanDay(item)">
                <img src="../../../assets/svg/del.svg" alt style="width: 70%;height: 70%;"/>
              </p>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="修改城市节点" :visible.sync="dialogVisible" width="30%">
      <city-autocomplete :obj="city" :action="false" @handleSelect="handleUpdateSelect" :sizeType="'medium'" :width="'margin-top:0.2rem'"></city-autocomplete>
      <p style="margin-top:0.1rem">
        <span style="color: #009900;font-weight: bold;">{{updateCityObj.cityName}}</span>
        <span>&nbsp;修改为&nbsp;</span>
        <span style="color: #009900;font-weight: bold;">{{updateCityNewObj.cityName}}</span>
      </p>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="updateCityPost">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title="删除当天" :visible.sync="deleteDayDialog" width="50%" class="deleteDayDialog">
      <p>
        <el-radio v-model="deleteChoose" label="1" v-if="deleteDayItem.planDay==1">删除该日期 及该日期内的所有城市及产品和说明</el-radio>
      </p>
      <p>
        <el-radio v-model="deleteChoose" label="2">删除该日期内所有城市及产品和说明，且将之后所有行程和产品和说明前挪一天（注意部分产会因使用日期变动而失效） </el-radio>
      </p>
      <p>
        <el-radio v-model="deleteChoose" label="3">保留日期，清空该日期内的所有城市及产品和说明</el-radio>
      </p>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="deleteDay">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import PlanApi from '@/components/Api/PlanApi.js'
import Api from '@/components/Api/index.js'
import { refresh } from '../js/function'
import { getPlanInfo,getBudgetInfo} from '../js/function'
import CityAutocomplete from '../../common/cityAutocomplete.vue'
export default {
  props:{
    chenckBudget:{
      type:Object,
      default:()=>{return {}}
    },
    showShaft:{
      type:Number,
      default:1,
    },
  },
  data(){
    return{
      checkPlanDay:1,
      city:{
        cityId:null,
        cityName:null,
      },
      editPlayDayState:false,
      departureDate:null,
      playDayNumber:null,
      dialogVisible:false,
      updateCityObj:{},
      updatePlanObj:{},
      updateCityNewObj:{},
      deleteDayDialog:false,
      deleteDayItem:{},
      deleteChoose:null,
    }
  },
  components:{CityAutocomplete,},
  methods:{
    changePlanDayAndStartDate(){
      this.editPlayDayState = true;
      this.departureDate = this.dateFormatYMD(this.chenckBudget.departureDate,'-')
      this.playDayNumber=this.chenckBudget.planDay
    },
    updateCityName(item,planObj){
      this.dialogVisible = true
      this.updateCityObj = item
      this.updatePlanObj = planObj
      this.updateCityNewObj = {}
      this.city.cityName=''
    },
    handleUpdateSelect(item){
      this.updateCityNewObj = this.cityToPlanCity(item)
      this.city.cityName = item.cityNameCn
    },
    updateCityPost(){
      var budgetIndex = this.updatePlanObj.budgetDetails ? this.updatePlanObj.budgetDetails.findIndex(e=>e.linkType==1&&e.startLinkId==this.updateCityObj.cityId) : -1;
      if(budgetIndex!=-1){
        this.$confirm('该天该城市有商品安排，如换掉该城市这些商品会被删除，是否继续？', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.updateCityPostApi()
        }).catch((err) => {})
      }else{
        this.updateCityPostApi()
      }
      
    },
    updateCityPostApi(){
      this.updateCityNewObj.budgetMainId = this.chenckBudget.id
      this.updateCityNewObj.id = this.updateCityObj.id
      new PlanApi('plan').updateCityTrafficType(this.updateCityNewObj).then(res => {
        if (res.status == 200) {
          this.dialogVisible = false
          refresh(res.data,this.chenckBudget.planId,this.chenckBudget.id)
        }
      })
    },
    changeTrafficType(i,type){
      this.$set(i,'trafficType',type)
      new PlanApi('plan').updateCityTrafficType({id:i.id,trafficType:type,budgetMainId:this.chenckBudget.id}).then(res => {})
    },
    changeCitySort(item1,item2,item){
      var cityList = []
      var sort = item1.sort
      item1.sort = item2.sort;
      item2.sort = sort;
      new PlanApi('plan').changeCitySort([item1,item2]).then(res => {
        if (res.status == 200) {
          var flag = true
          item.cityList.forEach(element => {
            if((element.id==item1.id||element.id==item2.id)){
              if(flag){
                cityList.push(item1)
                cityList.push(item2)
                flag = false
              }
            }else{
              cityList.push(element)
            }
          });
          item.cityList = cityList
        }else{
          this.$message({type:"error",message:res.statusText})
        }
      })
    },
    changePlanDay(item,i){
      this.checkPlanDay = item.planDay
      let doc = document.getElementById('planDayBudget'+this.checkPlanDay)
      if (doc) {
        doc.scrollIntoView()
      }
      //发送事件到行程轴右边做产品搜索
      this.$Bus.$emit('checkPlanObj',item,this.chenckBudget,i)
    },
    delPlanCity(item,index,arr,planObj){ 
      var budgetIndex = planObj.budgetDetails ? planObj.budgetDetails.findIndex(e=>e.linkType==1&&e.startLinkId==item.cityId) : -1;
      if(budgetIndex!=-1){
        this.$confirm('该天该城市有商品安排，如删除该城市这些商品会被同步删除，是否继续？', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.postDelCity(item,index,arr,planObj,'ref')
        }).catch((err) => {})
      }else{
        this.postDelCity(item,index,arr,planObj)
      }
    },
    postDelCity(item,index,arr,planObj,ref){
      new PlanApi('plan').delPlanCity({planCityId:item.id,budgetMainId:this.chenckBudget.id,planDays:this.chenckBudget.planDay}).then(res => {
        if (res.status == 200) {
          this.$message({type:"success",message:"城市删除成功"})
          if(this.chenckBudget.id==res.data.budgetMainId){
            arr.splice(index,1)
            this.$set(this.chenckBudget,'planName',res.data.planName)
            if(this.checkPlanDay==item.planDay){
              this.$Bus.$emit('checkPlanObj', planObj,this.chenckBudget)
            }
            this.$Bus.$emit('delCity',{'planCityId': item.id,'planDay': item.planDay})
            if(ref){
              getBudgetInfo(this.chenckBudget.id)
            }
          }else{
            getPlanInfo(this.chenckBudget.planId,res.data.budgetMainId)
          }
        }else{
          this.$message({type:"error",message:res.statusText})
        }
      }).catch(reason => {
        this.$message({type:"error",message:reason.response.data.message})
      })
    },
    saveChangePlanDays(){
      if(this.playDayNumber<this.chenckBudget.planDay){
        this.$confirm('您要更改的行程天少于之前的行程天数，超出部分的行程及产品将被删除，是否继续？', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.postChangePlanDays()
        }).catch((err) => {})
      }else{
        this.postChangePlanDays()
      }
    },
    postChangePlanDays(){
      new PlanApi('plan').updateBudgetMain({
        id:this.chenckBudget.id,
        planDay:this.playDayNumber,
        departureDate:this.departureDate
      }).then(res => {
        if (res.status == 200) {
          this.$message({type:"success",message:"修改成功"})
          this.editPlayDayState = false
          refresh(res.data,this.chenckBudget.planId,this.chenckBudget.id)
        }else{
          this.$message({type:"error",message:res.statusText})
        }
      })
    },
    addCity(item,index){
      if(index!=0){
        var prePlanDayCityList = this.chenckBudget.planDayList[index-1].cityList
        this.$set(this.chenckBudget.planDayList[index-1],'inputShowState',false)
        if(prePlanDayCityList.length>0&&item.cityList.length==0){
          var city = JSON.parse(JSON.stringify(prePlanDayCityList[prePlanDayCityList.length-1]))
          city.planDays = this.chenckBudget.planDay
          city.planDay = item.planDay
          city.sort = 1
          this.addCityPost(city,item,true)
        }
      }
      this.$set(item,'inputShowState',true)
      this.$nextTick(()=>{
        this.$refs['cityAutocomplete'+index][0].$refs.cityInput.focus()
      })     
    },
    addCityPost(city,planDayObj,flag){
      new PlanApi('plan').addPlanCity(city).then(res => {
        if (res.status == 200) {
          if(this.chenckBudget.id==res.data.budgetMainId){
            this.$set(planDayObj,'inputShowState',flag)
            if(!flag){
              new Api('resource').addCityHot({cityId:city.cityId}).then(res => {
                if (res.status == 200) {}
              })
            }
            this.$set(city,'id',res.data.planCityId)
            this.$Bus.$emit("addCity",city)
            planDayObj.cityList.push(city);
          }else{
            getPlanInfo(this.chenckBudget.planId,res.data.budgetMainId)
          }
        }else{
          this.$message({type:"error",message:res.statusText})
        }
      })
    },
    cityToPlanCity(item){
      var city={     
        cityId:item.id,
        cityName:item.cityNameCn,
        countryId:item.countryId,
        countryName:item.countryNameCn,   
        longitude:item.longitude,
        latitude:item.latitude,
        cityNameEn:item.cityName,
      }
      return city;
    },
    handleSelect(item,planDayObj){
      var city=this.cityToPlanCity(item)
      city.planId = this.chenckBudget.planId
      if(planDayObj.cityList.length>0){
        city.sort = planDayObj.cityList[planDayObj.cityList.length-1].sort+1
      }else{
        city.sort = 1
      }
      city.planDay = planDayObj.planDay
      city.planDays=this.chenckBudget.planDay,
      city.budgetMainId=this.chenckBudget.id,
      city.trafficType=1,
      this.addCityPost(city,planDayObj,false);
    },
    deleteDay(){
      new PlanApi('plan').delPlanDay({
        budgetMainId:this.chenckBudget.id,
        planDay:this.deleteDayItem.planDay,
        deleteType:this.deleteChoose
      }).then(res => {
        if (res.status == 200) {
          this.$message({type:"success",message:"修改成功"})
          this.deleteDayDialog = false
          refresh(res.data,this.chenckBudget.planId,this.chenckBudget.id)
        }else{
          this.$message({type:"error",message:res.statusText})
        }
      })
    },
    deletePlanDay(item){
      this.deleteDayItem = item
      this.deleteDayDialog = true
    },
    postUpdatePlanDay(type,item){
      new PlanApi('plan').addBeforeDay({
        budgetMainId:this.chenckBudget.id,
        planDay:item.planDay,
        oprateType:type
      }).then(res => {
        if (res.status == 200) {
          this.$message({type:"success",message:"修改成功"})
          refresh(res.data,this.chenckBudget.planId,this.chenckBudget.id)
        }else{
          this.$message({type:"error",message:res.statusText})
        }
      })
    },
    updatePlanDay(type,item){
      if(type==1){
        this.$confirm('前插一天会让出发日期提前一天(如不需要更改出发日期，请选择后插一天)，是否确认前插一天', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.postUpdatePlanDay(type,item)
        }).catch((err) => {})
      }else{
        this.postUpdatePlanDay(type,item)
      }
      
    }
  },
}
</script>

<style lang="scss" scoped>
.deleteDayDialog{
  p{
    margin-top: 0.1rem;
  }
}
.left{
  width: 2.6rem;
  .dateBox{
    /deep/ .el-input__inner{
      padding-right: 0 !important;
    }
  }
  >div:first-child{
    border: 1px solid #dcdcdc;
    border-radius: 4px;
    background: #fafafa;
    height: 0.4rem;
    padding: 0 0.1rem;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 0.12rem;
    a{
      color: #f54402;
      text-decoration: underline;
      cursor: pointer;
    }
  }
  >div:last-child{
    position: absolute;
    top: 0.5rem;
    bottom: 0rem;
    width: 2.6rem;
    border: 1px solid #dcdcdc;
    overflow-y: scroll;
    left: 0;
    >div{
      border-bottom: 1px solid #dcdcdc;
      padding: 0.2rem 0.08rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .planDay{
        width: 0.4rem;
        height: 0.4rem;
        border-radius: 50%;
        background: #da4e1a;
        font-weight: bold;
        text-align: center;
        line-height: 0.4rem;
        color: #fff;
      }
      .citycenter{
        width: 1.7rem;
        >p{
          color: #808080;
          font-size: 0.12rem;
        }
        >b{
          color: #40b8ff;
          font-weight: normal;
          cursor: pointer;
          font-size: 0.12rem;
          margin: 0.13rem 0px;
          display: inline-block;
        }
      }
      .oprateCityDiv{
        margin-right: 0.02rem;
        p{
          width: 0.08rem;
          height: 0.08rem;
          border-radius: 50%;
          background: #dddddd;
          cursor: pointer;
          margin-bottom: 0.04rem;
          display: flex;
          justify-content: center;
          align-items: center;
          img{
            width: 60%;
            height: 60%;
          }
        }
        >p:last-child{
          margin-bottom: 0px;
        }
      }
      .oprateCityDiv:hover{
        transform: scale(3);
      }
    }
  }
  >div:last-child::-webkit-scrollbar {
    display: none;
  }
}
</style>